import React, { Component } from "react";
import { Modal } from "./Modal";

import { ModalElement, modalManager } from "../Helper/ModalManager";

interface State { }

/** Global modal container managing stacking and display of modal windows. */
export class ModalContainer extends Component<any, State> {
    static displayName = ModalContainer.name;
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        modalManager.callbacks.push(this.onUpdate);
    }

    componentWillUnmount() {
        modalManager.callbacks = modalManager.callbacks.filter((x) => x !== this.onUpdate);
    }

    onUpdate = () => {
        this.setState({});
    };

    onHide = (element: ModalElement) => {
        modalManager.elements = modalManager.elements.filter((x) => x !== element);
        this.setState({});
    };

    render() {
        return (
            <div>
                {modalManager.elements.map((x, i) => (
                    <Modal
                        key={x.controller.id}
                        size={x.size}
                        show={
                            x.controller.display &&
                            modalManager.elements.filter((x) => x.controller.display).slice(-1)[0].controller.id ==
                            x.controller.id
                        }
                        onHide={() => modalManager.pop(x.controller.id)}
                        centered
                    >
                        {x.content}
                    </Modal>
                ))}
            </div>
        );
    }
}
